import type { ColorScheme } from '../../types'

const darkTokens = {
  trackOff: 'bg.toggle-track',
  trackOn: 'interactive.toggle-on',
  knob: 'fg.toggle-knob',
}

const lightTokens = {
  trackOff: 'light.bg.toggle-track',
  trackOn: 'light.interactive.toggle-on',
  knob: 'light.fg.toggle-knob',
}

export const getToggleTokens = (colorScheme: ColorScheme) =>
  colorScheme === 'light' ? lightTokens : darkTokens
